import { PaginationState, RowSelectionState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { ProductCatalogListItemResponseDto } from "~/gen/api"
import { useCatalogColumns } from "~/pages/Brand/Products/List/Components/ProductsTables/catalog/catalog-columns"

export type Props = {
  rowSelection: RowSelectionState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
  pageCount: number
  products: ProductCatalogListItemResponseDto[]
  pagination: PaginationState
  hasAgecComplianceFeatureAccess: boolean
}

export const useCatalogTable = ({
  rowSelection,
  setPagination,
  setRowSelection,
  pageCount,
  products,
  pagination,
  hasAgecComplianceFeatureAccess,
}: Props) => {
  const columns = useCatalogColumns({ hasAgecComplianceFeatureAccess })

  const table = useCustomReactTable({
    data: products,
    columns,
    initialColumnPinning: {
      left: ["name", "reference"],
    },
    state: {
      pagination,
      rowSelection,
    },
    getRowId: (row) => row.id,
    pageCount,
    manualPagination: true,
    enableRowSelection: true,
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
  })

  return table
}
